var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrowNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.452,
    height: 11.933,
    viewBox: "0 0 11.452 11.933",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(-1713.089 -860.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "expand-start-svgrepo-com",
    transform: "translate(1704.302 1104.243) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M241.761,14.513h0L237.29,9.995,238.5,8.787l5.726,5.726L238.5,20.239l-1.207-1.207Z",
    transform: "translate(0)",
    fill: "#808080",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "expand-start-svgrepo-com-2",
    "data-name": "expand-start-svgrepo-com",
    transform: "translate(1704.302 1109.243) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2-2",
    "data-name": "Path 2",
    d: "M241.761,14.513h0L237.29,9.995,238.5,8.787l5.726,5.726L238.5,20.239l-1.207-1.207Z",
    transform: "translate(0)",
    fill: "#808080",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowNew);
export default __webpack_public_path__ + "static/media/up-arrow-new.9d8950cf60cb1501903c9605ea7024c9.svg";
export { ForwardRef as ReactComponent };